import { FC, memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { Block } from '../../pages/pages.styled';
import { Text } from '../../components-v4';
import { useAppDispatch, useResponsive } from '../../../../hooks';
import { SmilesWrapper, Item } from './rate.styled';
import { getPublicRequestData, getPublicId } from '../../selectors';
import {
  ratePublicRequest,
  setRequestRating,
} from '../../request-single-page-slice';

export const Rate: FC = memo(() => {
  const dispatch = useAppDispatch();
  const { viewport } = useResponsive();
  const requestData = useSelector(getPublicRequestData);
  const publicId = useSelector(getPublicId);
  const [rate, setRate] = useState<number | null>(requestData.rating || null);

  const handleRate = (value: number) => {
    if (rate !== null) {
      return;
    }

    dispatch(
      ratePublicRequest({
        id: publicId,
        score: value,
      })
    )
      .then(unwrapResult)
      .then(() => {
        setRate(value);
        setRequestRating(value);
      });
  };

  return (
    <Block id="rate">
      <Text variant="heading-3" color="gray.800">
        Оцените качество нашей работы
      </Text>
      <Text variant={viewport.mobile ? 'body-14' : 'body-16'} color="gray.800">
        Ваш отзыв важен для нас, чтобы улучшать качество нашей работы.
      </Text>
      <SmilesWrapper>
        <Item
          isSelected={rate === 1}
          requestIsRated={rate !== null}
          onClick={() => handleRate(1)}
        >
          😞
        </Item>
        <Item
          isSelected={rate === 2}
          requestIsRated={rate !== null}
          onClick={() => handleRate(2)}
        >
          😕
        </Item>
        <Item
          isSelected={rate === 3}
          requestIsRated={rate !== null}
          onClick={() => handleRate(3)}
        >
          🙂
        </Item>
        <Item
          isSelected={rate === 4}
          requestIsRated={rate !== null}
          onClick={() => handleRate(4)}
        >
          😊
        </Item>
        <Item
          isSelected={rate === 5}
          requestIsRated={rate !== null}
          onClick={() => handleRate(5)}
        >
          🤩
        </Item>
      </SmilesWrapper>
      {rate !== null && (
        <Text
          variant={viewport.mobile ? 'body-14' : 'body-16'}
          color="gray.500"
          style={{ width: '100%', textAlign: 'center' }}
        >
          Оценка поставлена
        </Text>
      )}
    </Block>
  );
});
